"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isMobile = _interopRequireDefault(require("@ux/component-utilities/is-mobile"));
var _utils = require("./utils");
// eslint-disable-next-line complexity
function RangeIndicator(_ref) {
  let {
    range,
    allowClickUpdate,
    min,
    setValue,
    id,
    max,
    step,
    breakpoint,
    continuous,
    forceIndicators,
    side,
    value,
    rangeIndicators
  } = _ref;
  // mobile continuous sliders include a value label to the right of the slider
  // that replaces the standard range indicators
  const mobileIndicator = (0, _isMobile.default)(breakpoint) && continuous && !forceIndicators;

  /**
   * Decrease the value of the slider.
   *
   * @param {React.MouseEvent} ev Mouse Event
   * @private
   */
  const decreaseValue = (0, _utils.useEventCallback)(ev => {
    ev.preventDefault();
    if (!allowClickUpdate) return;
    const oldValue = value;
    const newValue = (0, _utils.getNearestStepValue)(oldValue - step, min, max, step);
    setValue(newValue);
  });

  /**
   * Increase the value of the slider.
   *
   * @param {React.MouseEvent} ev Mouse Event
   * @private
   */
  const increaseValue = (0, _utils.useEventCallback)(ev => {
    ev.preventDefault();
    if (!allowClickUpdate) return;
    const oldValue = value;
    const newValue = (0, _utils.getNearestStepValue)(oldValue + step, min, max, step);
    setValue(newValue);
  });
  const [rangeLeft = null, rangeRight = null] = rangeIndicators;
  const label = side === 'left' ? rangeLeft : rangeRight;
  const onClick = side === 'left' ? decreaseValue : increaseValue;
  const ariaLabel = side === 'left' ? '-' : '+';
  if (mobileIndicator && side === 'left' || rangeIndicators.includes(null)) return null;
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-controls": range ? void 0 : `${id}-thumb-0`,
    "aria-label": range ? void 0 : ariaLabel,
    tabIndex: range ? -1 : void 0,
    onClick: range ? void 0 : onClick,
    className: `ux-slider-range-indicator ${side} ${mobileIndicator ? 'mobile' : ''}`
  }, mobileIndicator ? value : label);
}
RangeIndicator.propTypes = {
  range: _propTypes.default.bool,
  rangeIndicators: _propTypes.default.array,
  allowClickUpdate: _propTypes.default.bool,
  min: _propTypes.default.number,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  setValue: _propTypes.default.func,
  id: _propTypes.default.string,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  breakpoint: _propTypes.default.string,
  continuous: _propTypes.default.bool,
  forceIndicators: _propTypes.default.bool,
  side: _propTypes.default.string
};
var _default = exports.default = RangeIndicator;